// Holds max / min resolutions to be used with react-responsive

export const PHONE = {
  MIN_WIDTH: 320,
  MAX_WIDTH: 767
};

export const TABLET = {
  MIN_WIDTH: 768,
  MAX_WIDTH: 1023
};

export const TABLET_BIG = {
  MIN_WIDTH: 1024,
  MAX_WIDTH: 1280
};
